import * as React from 'react';
import { hashHistory } from 'react-router';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { StyledHeader, PageTitle } from '../../components/MenuManager/Header/styles';
import Utils from '../../utils';
import { ResolutionDisplayType } from '../../utils/driveItem';
import { Api } from '../../typings/api';
import { Page } from '../Gallery/styles';
import { DriveItemActionIcons } from '../DriveItem/Detail/styles';
import { GalleryInfosState } from '../Gallery/reducer';
import { DriveListState, getDriveItemStatusFromMap, FetchStatus } from '../DriveItemList/reducer';
import { fetchDriveItem, getAllDriveItems, resolveParentId } from '../DriveItemList/actions';
import DriveItemDetail from '../DriveItem/Detail';
import SelectionToggler from '../Selection/Toggler';
import ShareButton from '../Share/ShareButton';
import RoutesUtils from '../../utils/routes';
import { DriveItemListOrigin } from '../DriveItemListPage/constants';
import UserAgentUtils from '../../utils/userAgent';

import { Translate } from 'react-redux-i18n';
import { BackButton } from './styles';
import { RouterParamsState } from '../SetRouteParams/reducer';
import { ShareOrigin } from '../Share/actions';

interface DriveItemDetailPageParams {
	driveItemId: string;
	folderId?: string;
}

interface DriveItemDetailPageProps {
	dispatch: Dispatch<StoreState>;
	params: DriveItemDetailPageParams;
	galleryInfos: GalleryInfosState;
	driveList: DriveListState;
	routerParamsHistory: RouterParamsState[];
}

class DriveItemDetailPage extends React.Component<DriveItemDetailPageProps, {}> {

	constructor(props: DriveItemDetailPageProps) {
		super(props);
		this.leavePage = this.leavePage.bind(this);
	}

	componentDidMount() {
		this.initializeView(this.props);
	}

	componentWillReceiveProps(nextProps: DriveItemDetailPageProps) {
		this.initializeView(nextProps);
	}

	leavePage = (): void => {
		const { params, driveList, galleryInfos, routerParamsHistory } = this.props;

		if (UserAgentUtils.isMobileApp || routerParamsHistory.length > 1 ) {
			window.history.back();
		} else {
			const driveItemId = parseInt(params.driveItemId, 10);
			const folderId = params.folderId ? parseInt(params.folderId, 10) : resolveParentId(driveItemId, driveList) as number;
			const originParam = folderId === galleryInfos.config.applicationGallery ||  !folderId ? '' : folderId.toString();

			window.location.hash = `#${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, originParam)}`;
		}
	}

	render() {
		const { leavePage } = this;
		const { galleryInfos, driveList } = this.props;
		const { resolutions, driveItems } = driveList;
		const { sharedMethods } = galleryInfos.template;
		const isShareable = sharedMethods && sharedMethods.includes(Api.ShareMethod.Share);
		const driveItemId = this.getDriveItemId();
		const driveItem = driveItems[driveItemId];

		return (
			<div>
				<StyledHeader>
					<div>
						{driveItem &&
							<BackButton onClick={leavePage}>
								{Utils.getSvgIcon('iconset_back')}
							</BackButton>
						}
					</div>
					<PageTitle><Translate value="messages.details" /></PageTitle>
					<DriveItemActionIcons>
						<SelectionToggler itemId={driveItemId} displayMode={ResolutionDisplayType.Detail} />
						{isShareable &&
							<ShareButton driveItems={[driveItem]} shareOrigin={ShareOrigin.Detail}/>
						}
					</DriveItemActionIcons>
				</StyledHeader>
				<Page>
					{(driveItem && resolutions) &&
						<DriveItemDetail driveItem={driveItem} resolutions={resolutions} />
					}
				</Page>
			</div>
		);
	}

	private initializeView(props: DriveItemDetailPageProps): void {
		const { dispatch, driveList } = props;
		const { driveItems } = driveList;
		const driveItemId = this.getDriveItemId();
		const driveItem = driveItems[driveItemId];
		const { metaFetchStatus } = getDriveItemStatusFromMap(driveList.driveItemsFetchStatus, driveItemId);

		if (!driveItem) {
			if (metaFetchStatus !== FetchStatus.ERROR) {
				dispatch(fetchDriveItem(driveItemId));
			} else {
				hashHistory.replace('');
				return;
			}
		}

		if (!props.params.folderId && UserAgentUtils.isOnline()) {
			dispatch(getAllDriveItems());
		}
	}

	private getDriveItemId(): number {
		const { params } = this.props;
		return parseInt(params.driveItemId, 10);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, driveList, routerParamsHistory } = state;
	return { galleryInfos, driveList, routerParamsHistory };
};

export default connect(mapStateToProps)(DriveItemDetailPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemDetailPage/index.tsx